/*
 * Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { catchError, map, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { Action } from '@ngrx/store';
import {
  LOAD_ALL_TENANT_DETAILS,
  LoadAllTenantDetailsSuccess,
  LoadAllTenantDetailsError,
  LOAD_PREVIEW_ENVIRONMENTS,
  LoadPreviewEnvironmentsSuccess,
  LoadPreviewEnvironmentsError
} from './shared-data.actions';
import { observableOf } from 'app/shared/rxjs/rxjs.utils';
import { SharedDataService } from 'app/shared-data/services/shared-data.service';

@Injectable()
export class SharedDataEffects {
  /** Load preview environments trigger. */

  loadPreviewEnvironments: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(LOAD_PREVIEW_ENVIRONMENTS),
      switchMap(() =>
        this.dataService.previewEnvironments().pipe(
          map(result => new LoadPreviewEnvironmentsSuccess(result)),
          catchError(err => observableOf(new LoadPreviewEnvironmentsError(err)))
        )
      )
    )
  );

  /** Load all tenant details API trigger. */

  loadTenants: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(LOAD_ALL_TENANT_DETAILS),
      switchMap(() =>
        this.dataService.tenants().pipe(
          map(value => new LoadAllTenantDetailsSuccess(value)),
          catchError(err => observableOf(new LoadAllTenantDetailsError(err)))
        )
      )
    )
  );

  constructor(private actions: Actions, private dataService: SharedDataService) {}
}
